import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AdminDataService } from "src/app/_services/admin.data.service";
import { AuthenticationService } from "src/app/_services/authenticationService";
import { DialogServiceService } from "../dialog-service.service";
import { environment } from "src/environments/environment";
import {
    buildImpersonationToken,
    buildImpersonationUrl,
} from "src/app/_app-core/impersonation-url";

@Component({
    selector: "app-impersonate-dialog",
    templateUrl: "./impersonate-dialog.component.html",
    styleUrls: ["./impersonate-dialog.component.scss"],
})
export class ImpersonateDialogComponent implements OnInit {
    @Input() title = "Impersonate";
    @Input() message;
    /** GPXUSAP-1860: set to "UPLOAD_ON_BEHALF" when this hand-off originates
     * from the manage-vendors "Upload invoice" row action, undefined for
     * plain Impersonate. */
    @Input() intent?: string;
    constructor(
        public activeModal: NgbActiveModal,
        private adminService: AdminDataService,
        private authService: AuthenticationService,
        private dialogService: DialogServiceService
    ) {}

    ngOnInit(): void {}

    impersonate() {
        if (this.impersonateInFlight) {
            return;
        }
        this.impersonateInFlight = true;
        ///localStorage.clear();
        console.log("Trying to impersonate here");
        const userData = this.authService.currentUserData;
        const vendorCode = this.adminService.getImpersonateVendorCode();
        console.log(vendorCode);
        console.log(userData.loginData.user.eippSession);

        const reqData: {
            supplierCode: any;
            session: any;
            sellerCode: any;
            intent?: string;
        } = {
            supplierCode: vendorCode,
            session: userData.loginData.user.eippSession,
            sellerCode: userData.userData.sellerCode,
        };
        if (this.intent === "UPLOAD_ON_BEHALF") {
            reqData.intent = this.intent;
        }

        localStorage.setItem("sellerCode", vendorCode);

        this.activeModal.close(false);
        this.dialogService.showWaitDialog();
        console.log(reqData);

        this.adminService.adminImpersonate(reqData).subscribe({
            next: (data) => {
                if (data && data.success) {
                    if (!data.data?.user?.enforcePasswordChange) {
                        const vendorBase = String(
                            environment.vendorUrl || ""
                        ).trim();
                        // GPXUSAP-1860 fix round 2: the vendor SPA parses this
                        // token POSITIONALLY up to pathSplit[8], and
                        // pathSplit[5] is `username` (posted to its impersonate
                        // API) — a 6th "$$$"-joined segment would collide with
                        // that slot. buildImpersonationToken always returns
                        // exactly five segments, byte-identical on both the
                        // plain-Impersonate and upload-on-behalf paths;
                        // buildImpersonationUrl carries the landing as a
                        // separate `landing` query param, added ONLY for the
                        // upload-on-behalf hand-off.
                        const token = buildImpersonationToken({
                            sessionId: userData.loginData.user.eippSession
                                .sessionId,
                            vendorCode,
                            userName: userData.userName,
                            loginUsername: userData.loginUsername,
                            sellerCode: userData.userData.sellerCode,
                        });
                        window.location.href = buildImpersonationUrl(
                            vendorBase,
                            token,
                            this.intent
                        );
                    } else {
                        console.log("user hasn't onboarded");
                    }
                } else {
                    // GPXUSAP-1860 fix round 6: a refused impersonation
                    // (e.g. PXAP_IMPERSONATE_FORBIDDEN) previously landed
                    // here silently whenever `data.message` was missing —
                    // do not navigate away, and always surface something.
                    this.impersonateInFlight = false;
                    this.dialogService.hideWaitDialog();
                    this.dialogService.showInfoDialog(
                        "Error",
                        (data && data.message) ||
                            "Unable to impersonate this vendor.",
                        "sm",
                        false
                    );
                    console.log(data);
                }
            },
            error: (err) => {
                // GPXUSAP-1860 fix round 6: the forbidden case comes back as
                // a transport-level (non-2xx) error, not a `success:false`
                // body — this subscribe previously had no error callback at
                // all, so it was swallowed and the dialog just closed with
                // no feedback. Do NOT navigate away here either.
                this.impersonateInFlight = false;
                this.dialogService.hideWaitDialog();
                const message =
                    err?.error?.message ||
                    err?.error?.msg ||
                    (typeof err?.error === "string" ? err.error : null) ||
                    err?.message ||
                    "Unable to impersonate this vendor.";
                this.dialogService.showInfoDialog("Error", message, "sm", false);
                console.log(err);
            },
        });

        //console.log(reqData);
    }

    /** Blocks a second impersonate() (double click while the confirm
     * dialog is fading out) from firing a second request and a second
     * wait/error popup. */
    private impersonateInFlight = false;
}
